import { createContext } from 'react';
import { AnyPage } from '../cms';
import { Color } from '../colors';
import { Locale } from '../const';

export const PageContext = createContext<AnyPage>({
  id: 0,
  title: '',
  locale: Locale.En,
  localizations: [],
  // @ts-ignore (content is missing for cars, but we don't care)
  content: [],
  slug: '',
  path: '',
  createdAt: '',
  updatedAt: '',
  structuredData: null,
  audiences: [],
  metaTitle: '',
  metaDescription: '',
  metaRobots: '',
  canonical: undefined,
  manufacturer: '',
  model: '',
  isSearchable: true,
  template: {
    id: 0,
    calculatorChargingCostHeadline: '',
    calculatorChargingDurationHeadline: '',
    calculatorChargingDurationTeaser: '',
    calculatorChargingDurationText: '',
    highlightedProductSliderHeadline: '',
    highlightedProductSliderEntries: [],
    verticalCardsSliderHeadline: '',
    verticalCardsSliderTeaser: '',
    createdAt: '',
    updatedAt: '',
    heroImage: '',
    heroHeadline: '',
    heroButtonText: '',
    locale: Locale.En,
  },
  headerTheme: Color.Neutral_0_White,
});
